import React from 'react'
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useDisclosure,
    Button,
    useToast,
} from '@chakra-ui/react'

const AttachAlertBox = ({ deleteFunction, data }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const cancelRef = React.useRef()

    const toast = useToast()
    function toster() {
        toast({
            title: 'Attach deleted.',
            description: "Attach has been deleted.",
            status: 'warning',
            duration: 9000,
            isClosable: true,
            size: "lg"
        })
    }

    return (
        <>
            <Button colorScheme='red' onClick={onOpen}>
                Delete Attach
            </Button>

            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            Delete Attachment
                        </AlertDialogHeader>

                        <AlertDialogBody fontSize={"large"} >
                            Are you sure? You can't undo this action afterwards.
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Cancel
                            </Button>
                            <Button colorScheme='red' onClick={() => {
                                deleteFunction(data)
                                onClose()
                                toster()
                            }} ml={3}>
                                Delete
                            </Button>

                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}

export default AttachAlertBox